import { defineMessages } from 'react-intl';

export const messages: {
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageTitleLowAdoption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageTitleHighAdoption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageTitleLowAdoptionInline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageTitleHighAdoptionInline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageConnect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSocialProofMessageImageAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismiss: {
		// NOTE: i18n `id`s are intentionally kept stable across the
		// OAuthMessageWithPreview → OAuthSocialProofMessage rename so existing
		// translations are not lost.
		id: 'oauth-banner.oauth-social-proof-message.dismiss',
		defaultMessage: 'Dismiss',
		description:
			'Label for the secondary dismiss text button on oauth social proof message, shown next to the primary "Connect" CTA',
	},
	oauthSocialProofMessageTitleLowAdoption: {
		id: 'oauth-banner.oauth-social-proof-message.title-low-adoption',
		defaultMessage: 'Your team connected {product}',
		description:
			'Title of oauth social proof message when team-connected adoption is low (< 30%); {product} is the connector display name (e.g. "GitHub")',
	},
	oauthSocialProofMessageTitleHighAdoption: {
		id: 'oauth-banner.oauth-social-proof-message.title-high-adoption',
		defaultMessage: '{percentage}% of your team has connected apps like {product}',
		description:
			'Title of oauth social proof message when team-connected adoption is moderate or high (>30%); {percentage} is the connected-teammate percentage and {product} is the connector display name (e.g. "GitHub")',
	},
	oauthSocialProofMessageTitleLowAdoptionInline: {
		id: 'oauth-banner.oauth-social-proof-message.title-low-adoption-inline',
		defaultMessage: 'Your team connected {product}.',
		description:
			'Title of the one-line (inline) oauth social proof banner when team-connected adoption is low (< 30%). It is rendered on the same line as, and immediately followed by, the description body copy, so it is terminated with sentence-final punctuation. Translators should localise the terminal punctuation to their language (e.g. use the ideographic full stop in Chinese/Japanese, or omit it in Thai). {product} is the connector display name (e.g. "GitHub").',
	},
	oauthSocialProofMessageTitleHighAdoptionInline: {
		id: 'oauth-banner.oauth-social-proof-message.title-high-adoption-inline',
		defaultMessage: '{percentage}% of your team has connected apps like {product}.',
		description:
			'Title of the one-line (inline) oauth social proof banner when team-connected adoption is moderate or high (> 30%). It is rendered on the same line as, and immediately followed by, the description body copy, so it is terminated with sentence-final punctuation. Translators should localise the terminal punctuation to their language (e.g. use the ideographic full stop in Chinese/Japanese, or omit it in Thai). {percentage} is the connected-teammate percentage and {product} is the connector display name (e.g. "GitHub").',
	},
	oauthSocialProofMessageConnect: {
		id: 'oauth-banner.oauth-social-proof-message.connect',
		defaultMessage: 'Connect to {product}',
		description:
			'Primary CTA label on oauth social proof message; {product} is the connector display name (e.g. "GitHub")',
	},
	oauthSocialProofMessageImageAlt: {
		id: 'oauth-banner.oauth-social-proof-message.image-alt',
		defaultMessage: 'Animated preview of {product} search results',
		description:
			'Localised alt text for the banner-side preview image on oauth social proof message; {product} is the connector display name (e.g. "GitHub")',
	},
});
